import { addSpace } from '../../utils/print';

function formatPrintContent(filterArray) {
  if (!filterArray.length) {
    return '';
  }

  const content = addSpace(filterArray).join(', ');
  return content;
}

export function getPrintDownAndDistanceValues(state) {
  const downDistance = Object.keys(state.football.downDistance.selections);
  return formatPrintContent(downDistance);
}

export function getPrintFieldZoneValues(state) {
  const fieldZone = Object.keys(state.football.fieldZone.selections);
  return formatPrintContent(fieldZone);
}

export function getPrintBreadcrumbsValues(state) {
  const breadcrumbs = state.breadcrumbs.map(({ printValue }) => printValue);
  return formatPrintContent(breadcrumbs);
}

export function getPrintGameValues(state) {
  const { games } = state.teamSeasonGameSelection;
  return formatPrintContent(games);
}
